import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token') || '')
  const refreshToken = ref(localStorage.getItem('refreshToken') || '')
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'))
  const isAdmin = ref(user.value?.is_superuser)

  // 设置用户信息和token
  const setUserInfo = (data) => {
    token.value = data.token
    refreshToken.value = data.refresh
    user.value = data.user
    
    // 保存到本地存储
    localStorage.setItem('token', data.token)
    localStorage.setItem('refreshToken', data.refresh)
    localStorage.setItem('user', JSON.stringify(data.user))
  }

  // 清除用户信息
  const clearUserInfo = () => {
    token.value = ''
    refreshToken.value = ''
    user.value = null
    
    // 清除本地存储
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
  }

  // 判断是否已登录
  const isAuthenticated = () => {
    return !!token.value
  }

  return {
    token,
    refreshToken,
    user,
    setUserInfo,
    clearUserInfo,
    isAuthenticated,
    isAdmin
  }
}) 